import {Settings} from './settings.js';
export default Settings